import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '_store';

export { PrivateRoute };

function PrivateRoute({ children }) {
    const location = useLocation();
    const { authUser, loading, sessionEndReason } = useContext(AuthContext);
    if (loading) {
        return null;
    }
    if (!authUser) {
        const from = sessionEndReason === 'expired'
            ? `${location.pathname}${location.search}${location.hash}`
            : '/';
        return <Navigate to="/login" replace state={{ reason: sessionEndReason, from }} />;
    }

    // Authorized, return child components
    return children;
}
